module.exports = __webpack_public_path__ + "img/woodpacking-en.6e528ae3.svg";